// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import LoadingIcon from '../../../LoadingIcon';
import { actionCreatorsList } from '../../../../redux/rootActionCreator';
import ExamSelector from '../../../../redux/selectors/ExamSelector';
import { CompletionStatusType } from '../../../../types/Model';

import { S } from './styles';

interface ExamModuleProps {
  id: number;
  status?: CompletionStatusType;
  courseId: number;
  courseType: string;
  triggerProgress: () => void;
  handleNextModule: () => void;
}

function useGetExamInformation(id: number) {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(actionCreatorsList.getExamInformationActions.request({
      id,
      condition: 'buy'
    }))
  }, [id]);
}

const ExamContent: React.FC<ExamModuleProps> = ({ id, status, triggerProgress, handleNextModule, courseId, courseType }): JSX.Element => {
  const exam = useSelector(ExamSelector.makeExamByIdSelector(id));
  const isExamFetching = useSelector(ExamSelector.makeIsFetchingExam());
  const fromWorkshop = courseType === 'workshops' ? `?workshopId=${courseId}` : ''
  const fromCourse = courseType === 'onlineCourses' ? `?courseId=${courseId}` : ''
  const fromIltCourse = courseType === 'iltCourses' ? `?iltCourseId=${courseId}` : ''
  const examUrl = `/exams/${id}${fromWorkshop}${fromCourse}${fromIltCourse}`
  const getExamInformation = useGetExamInformation(id);
  useEffect(() => {
    getExamInformation();
  }, [id])

  if (isExamFetching) {
    return (
      <S.Container>
        <LoadingIcon size={15} />
      </S.Container>
    );
  }

  return (
    <S.Container>
      <S.Row>
        <S.InformationContainer>
          <S.Title><FormattedMessage id="F043" />{exam.name}</S.Title>
          <S.Overview>{exam.overview}</S.Overview>
        </S.InformationContainer>
        <S.ExamImage />
      </S.Row>
      <S.Row>
        <S.Button as={Link} to={examUrl} target="_blank"><FormattedMessage id="F042" /></S.Button>
        {status === CompletionStatusType.COMPLETED && <S.Button onClick={handleNextModule}><FormattedMessage id="F015" /></S.Button>}
      </S.Row>
    </S.Container>
  );
}

export { ExamContent as default };
